import React from "react";
import R14, { StyleSheet, View, Text, Button, Checkbox, Image, FlatList } from "../core";

import { commonStyles } from "../assets/css/commonStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import PCHLoaderComponent from "./PCH/PCHLoaderComponent";

import { responsiveTableStyle } from "../assets/css/responsiveTableStyle";
import NoRecordsFound from "../components/NoRecordsFound";
import { CommonString } from "../constant/appCommonText";
import { MESSAGE_TYPE } from "../constant/app.data.constant";
import PopupModalComponent from "./PopupModalComponent";

import varifed from "../assets/images/selete_icon_active.png";

export default R14.connect(
  class LinkPayerComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isLoading: true,
        selectedPIDs: [],
        suggestionPIDs: [],
        userLoginDetail: {},
        message: "",
        isDisable: true,
        isLinkRequestSubmit: false,
        isConfirmationVisible: false
      };
    }

    async componentDidMount() {
      try {
        let suggestionPIDs = await this.props.app.dm.simpleMessage.getLinkPIDSuggestions();
        const userLoginDetail = await this.props.app.dm.rest.getUser();
        let selectedPIDs = [];
        if (suggestionPIDs && suggestionPIDs.suggestions) {
          suggestionPIDs = suggestionPIDs.suggestions.map(suggestion => {
            if (suggestion.email === userLoginDetail.email) selectedPIDs.push({ buId: suggestion.buId, billerPID: suggestion.billerPID, payerPID: suggestion.payerPID });
            return suggestion;
          });
          selectedPIDs = selectedPIDs.filter((value, index, array) => array.indexOf(value) === index);
          suggestionPIDs = suggestionPIDs.filter(suggestion => !!suggestion.buId && !!suggestion.billerRef)
          if (selectedPIDs.filter(x => x.payerPID !== userLoginDetail.pid).length > 0) {
            this.setState({
              isDisable: false
            })
          }
          this.setState({
            suggestionPIDs: suggestionPIDs,
            userLoginDetail,
            selectedPIDs,
            isLoading: false
          })
        } else this.setState({ isLoading: false });
      } catch (error) {
        this.setState({ isLoading: false });
      }
    }

    handleSubmit = async () => {
      const { selectedPIDs, userLoginDetail, suggestionPIDs } = this.state;
      if (selectedPIDs.filter(x => x.payerPID !== userLoginDetail.pid).length > 0) {
        let primaryPID = suggestionPIDs.find(x=> x.payerPID === userLoginDetail.pid);
        const res = await this.props.app.dm.simpleMessage.postLinkPayerPID(selectedPIDs, primaryPID);
        if (res) {
          this.setState({
            isLinkRequestSubmit: true,
            message: 'Your request for linking the Payer is submitted.  The request status will be updated on acceptance/decline by the Payer.'
          })
        } else {
          this.props.app.dm.commonDomain.showToastr("error", CommonString.SomethingWentWrong);
        }
      }
      else {
        this.setState({
          isLinkRequestSubmit: true,
          message: 'Selected & Login payer details are same with accepted status.'
        })
      }
      return false;
    };

    onCancel = () => {
      this.props.app.nav.back();
    }

    handleAlertPopUp = () => {
      const { isLinkRequestSubmit, isConfirmationVisible } = this.state;
      if (isConfirmationVisible) this.setState({ isConfirmationVisible: false });
      if (isLinkRequestSubmit) {
        // redirect to back page
        this.props.app.nav.back();
        this.setState({
          isLinkRequestSubmit: false,
          message: "",
          selectedPIDs: [],
        });
      }
      return false;
    }

    // Delete confirmation popup model with Yes/No buttons
    alertModelPopUp = () => {
      const { isLinkRequestSubmit, isConfirmationVisible, message } = this.state;
      return (
        <PopupModalComponent
          visibility={isConfirmationVisible || isLinkRequestSubmit}
          bodyWrapper={[styles.bodyWrapper]}
          messageType={MESSAGE_TYPE.info}
          headingIcon={true}
          heading={"Info"}
          modalContent={[commonStyles.marginTop10, commonStyles.marginBottom10]}
          bodyContent={isLinkRequestSubmit ? message : 'You share the same Email as Payer Email. If you do not wish to link this Payer, please contact support.'}
          okLabel={"Ok"}
          handleOk={this.handleAlertPopUp}
          closeLabel={""}
          handleClose={null}
        />
      )
    }

    toggleCheckBox = async (item) => {
      const { selectedPIDs, userLoginDetail } = this.state;
      const isSelected = selectedPIDs.findIndex(arr => arr.payerPID === item.payerPID && arr.billerPID === item.billerPID && arr.buId === item.buId)
      if (isSelected !== -1) {
        if (item.email === userLoginDetail.email) {
          return this.setState({ isConfirmationVisible: true })
        }
        const removedSelectedItem = selectedPIDs.filter(arr => !(arr.payerPID === item.payerPID && arr.billerPID === item.billerPID && arr.buId === item.buId));
        this.setState({
          selectedPIDs: removedSelectedItem
        });
      } else {
        selectedPIDs.push({ payerPID: item.payerPID, billerPID: item.billerPID, buId: item.buId });
        this.setState({
          selectedPIDs: selectedPIDs
        })
      }

      if (selectedPIDs.filter(x => x.payerPID !== userLoginDetail.pid).length > 0) {
        this.setState({
          isDisable: false
        })
      }
    };

    render() {
      const { selectedPIDs, suggestionPIDs, isLoading, isDisable } = this.state;
      return (
        <>
          {isLoading ? (
            <PCHLoaderComponent isVisiable={isLoading} labelText={"Please wait"} />
          ) : !suggestionPIDs || !suggestionPIDs.length ? (
            <View style={[styles.noItemsComponent]}>
              <NoRecordsFound message={"No link payer suggestion to display."} />
            </View>
          ) : (
            <View style={[styles.greyBackground]}>
              <View style={[responsiveTableStyle.myBankMainSection]}>
                {/* Web View Start */}
                <View style={[styles.table, !!this.state.suggestionPIDs.length <= 0 ? responsiveTableStyle.tablepadding : null, commonStyles.flex1]}>
                  {!!suggestionPIDs.length > 0 ? (
                    <View style={[styles.table, commonStyles.margin0, commonStyles.padding0, styles.borderWidth0, commonStyles.marginTop15, commonStyles.paddingLeftRight16]}>
                      <View
                        style={[
                          styles.thead,
                          commonStyles.flexGrow0,
                          commonStyles.justifyContentSpaceBetween,
                          commonStyles.flexDirectionRow,
                        ]}>
                        {/* Checkbox */}
                        <View style={[styles.checkboxContainer]}>
                          {/* <Checkbox
                                name={"selectAll"}
                                label={"selectAll"}
                                value={selectedPIDs.length === suggestionPIDs.length && selectedPIDs.length !== 0}
                                onPress={() => this.toggleCheckBox("selectAll")}
                                colorBlank="#585858"
                                colorMarked="#4dc5f2"
                                disabled={false}
                              /> */}
                        </View>
                        <View style={styles.th}>
                          <Text style={[commonFontStyles.workSans, commonStyles.fontWeight500, commonStyles.heading6]}>Biller</Text>
                        </View>
                        <View style={styles.th}>
                          <Text style={[commonFontStyles.workSans, commonStyles.fontWeight500, commonStyles.heading6]}>Payer</Text>
                        </View>
                        <View style={[styles.th, styles.thStatus]}>
                          <Text style={[commonFontStyles.workSans, commonStyles.fontWeight500, commonStyles.heading6]}>Email Status</Text>
                        </View>
                        <View style={[styles.th, styles.thStatus]}>
                          <Text style={[commonFontStyles.workSans, commonStyles.fontWeight500, commonStyles.heading6]}>SMS Status</Text>
                        </View>
                      </View>
                    </View>
                  ) : null}
                  <View>
                    <FlatList
                      style={[styles.providerListComponent, suggestionPIDs && suggestionPIDs.length > 0 ? customCommonStyles.customProviderListComponent : styles.noPIDComponent, styles.customMarginTop, styles.borderBottomWidth0, styles.marginLeftRight16, styles.customListHeight]}
                      data={suggestionPIDs ? suggestionPIDs : []}
                      keyExtractor={(el, i) => i}
                      // onLayout={(event) => this.getHeightOfElement(event)}
                      ListEmptyComponent={
                        <View style={styles.padd10}>
                          <NoRecordsFound noRecords={[commonStyles.marginTop15, styles.noRecordFound]} message={"No PID suggestion to display."} />
                        </View>
                      }
                      renderItem={({ item, index }) => (
                        <View style={styles.body}>
                          <View style={[styles.tr, commonStyles.flex1, commonStyles.flexDirectionRow, styles.justifyContentSpaceBetween]}>
                            {/* Checkbox */}
                            <View style={[styles.checkboxContainer, item.isPrimary ? commonStyles.flexDirectionRow : null]}>
                              <Checkbox
                                name={item.buId + index}
                                label={item.buId}
                                value={selectedPIDs.findIndex(arr => arr.payerPID === item.payerPID && arr.billerPID === item.billerPID && arr.buId === item.buId) !== -1 ? true :
                                  false}
                                onPress={() => this.toggleCheckBox(item)}
                                colorBlank="#585858"
                                colorMarked="#4dc5f2"
                                disabled={item.emailStatus === "Requested" || item.mobileStatus === "Requested" || item.emailStatus === "Accepted" || item.mobileStatus === "Accepted" ? true : false}
                              />
                            </View>
                            <View style={[commonStyles.flex1, styles.customFlexDirection]}>
                              {/* Address */}
                              <View style={[styles.td, commonStyles.paddingRight16, item.isPrimary ? commonStyles.flexDirectionRow : null]}>
                                <View
                                  style={[
                                    commonStyles.mView,
                                    commonStyles.marginBottom5,
                                    styles.mobileLabels,
                                  ]}
                                >
                                  <Text
                                    style={[
                                      commonFontStyles.workSans,
                                      commonStyles.fontWeight600,
                                      commonStyles.heading6,
                                    ]}
                                  >
                                    Biller:
                                  </Text>
                                </View>
                                {/* Primary Address icon */}
                                <View style={[item.isPrimary ? null : commonStyles.displayNone, item.isPrimary ? styles.paddingRight5 : null]}>
                                  <Image source={varifed} style={commonStyles.icon18} />
                                </View>
                                <View style={[customCommonStyles.valueInMbileBreakWord]}>
                                  <Text
                                    style={[commonFontStyles.workSans, commonStyles.heading6, styles.flexWrap]}
                                  >
                                    {`${item.billerName}\n${item.buName}\n${item.billerRef} (${item.billerPID})`}
                                  </Text>
                                </View>
                              </View>

                              {/* town */}
                              <View style={[styles.td, commonStyles.paddingRight16]}>
                                <View
                                  style={[
                                    commonStyles.mView,
                                    commonStyles.marginBottom5,
                                    styles.mobileLabels,
                                  ]}
                                >
                                  <Text
                                    style={[
                                      commonFontStyles.workSans,
                                      commonStyles.fontWeight600,
                                      commonStyles.heading6,
                                    ]}
                                  >
                                    Payer:
                                  </Text>
                                </View>
                                <View style={[customCommonStyles.valueInMbileBreakWord]}>
                                  <Text
                                    style={[commonFontStyles.workSans, commonStyles.heading6, styles.flexWrap]}
                                  >
                                    {`${item.payerName}\n${item.email}\n${item.phone}\n${item.payerRef} (${item.payerPID})`}
                                  </Text>
                                </View>
                              </View>
                              <View style={[styles.td, styles.tdStatus, commonStyles.paddingRight16]}>
                                <View
                                  style={[
                                    commonStyles.mView,
                                    commonStyles.marginBottom5,
                                    styles.mobileLabels,
                                  ]}
                                >
                                  <Text
                                    style={[
                                      commonFontStyles.workSans,
                                      commonStyles.fontWeight600,
                                      commonStyles.heading6,
                                    ]}
                                  >
                                    Email Status:
                                  </Text>
                                </View>
                                <View style={[customCommonStyles.valueInMbileBreakWord]}>
                                  <Text
                                    style={[commonFontStyles.workSans, commonStyles.heading6]}
                                  >
                                    {item.emailStatus ? item.emailStatus : "Not Linked"}
                                  </Text>
                                </View>
                              </View>
                              {/* post code */}
                              <View style={[styles.td, styles.tdStatus, commonStyles.paddingRight16]}>
                                <View
                                  style={[
                                    commonStyles.mView,
                                    commonStyles.marginBottom5,
                                    styles.mobileLabels,
                                  ]}
                                >
                                  <Text
                                    style={[
                                      commonFontStyles.workSans,
                                      commonStyles.fontWeight600,
                                      commonStyles.heading6,
                                    ]}
                                  >
                                    SMS Status:
                                  </Text>
                                </View>
                                <View style={[customCommonStyles.valueInMbileBreakWord]}>
                                  <Text
                                    style={[commonFontStyles.workSans, commonStyles.heading6]}
                                  >
                                    {item.mobileStatus ? item.mobileStatus : "Not Linked"}
                                  </Text>
                                </View>
                              </View>
                            </View>
                          </View>
                        </View>
                      )}
                    />
                  </View>
                  <View style={[commonStyles.smallModalBtnWrapper, commonStyles.flex1, commonStyles.flexDirectionRow, styles.pidButtonContainer]}>
                    <Button
                      title={"Cancel"}
                      style={[commonStyles.blueBorderButton, commonStyles.addInsuranceAlertOkBtn, customCommonStyles.noBoxShadow, commonStyles.marginRight16, styles.customInactiveBtnStyle, commonStyles.btnHeight24]}
                      onPress={() => this.onCancel()}
                      key="cancel"
                      titleTextStyle={[
                        commonFontStyles.workSans,
                        commonStyles.fontWeight500,
                        commonStyles.heading6,
                        commonStyles.transperentBtnColor,
                        commonStyles.blueBorderButtonColor,
                      ]}
                    />
                    <Button
                      title={"Submit"}
                      style={[commonStyles.blueButton, commonStyles.marginRight8, commonStyles.addInsuranceAlertOkBtn, customCommonStyles.noBoxShadow, (!selectedPIDs.length || !!isDisable) && customCommonStyles.disabledBtn, styles.customActiveBtnStyle, commonStyles.btnHeight24]}
                      onPress={() => (!!selectedPIDs.length && !isDisable) ? this.handleSubmit() : null}
                      key="handleSubmit"
                      titleTextStyle={[
                        commonFontStyles.workSans,
                        commonStyles.fontWeight500,
                        commonStyles.heading6,
                        commonStyles.transperentBtnColor,
                        commonStyles.whiteColor,
                      ]}
                    />
                  </View>
                </View>
              </View>
              {/* PopUP */}
              {this.alertModelPopUp()}
            </View>
          )
          }
        </>
      );
    }
  }
);

const styles = StyleSheet.create({
  table: {
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    backgroundColor: "#fff",
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    borderWidth: 0,
    borderColor: "#e2e2e2",
    borderStyle: "solid",
    borderBottomWidth: 0,
    // screen: ({ width }) => {
    //   if (width <= 991)
    //     return {
    //       display: "none"
    //     };
    // },
  },
  block: { display: "block" },
  none: { display: "none" },
  noStyle: {},
  textFieldsHolder: {
    screen: ({ width }) => {
      if (width <= 991)
        return {
          flexDirection: "column",
        };
    },
  },
  thead: {
    paddingTop: 10,
    paddingRight: 16,
    paddingBottom: 10,
    paddingLeft: 16,
    position: "relative",
    flex: 1,
    flexDirection: "row",
    zIndex: 999,
    backgroundColor: "#e5e5e5",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    maxHeight: 40,
    screen: ({ width }) => {
      if (width <= 991)
        return {
          display: "none",
        };
    },
  },
  tr: {
    justifyContent: "space-between",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#dadada",
    borderTop: 0,
    paddingTop: 0,
    paddingRight: 16,
    paddingBottom: 10,
    paddingLeft: 16,
    position: "relative",
    screen: ({ width }) => {
      if (width <= 991)
        return {
          borderWidth: 0,
          borderBottomWidth: 1,
          marginRight: 0,
          marginLeft: 0,
          paddingTop: 10,
          paddingRight: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          borderLeft: 0,
          borderRight: 0,
          flex: 1,
          flexDirection: "row",
        };
    },
  },
  th: {
    flex: 1,
    flexBasis: "35%",
    maxWidth: "35%",
  },
  thStatus: {
    flex: 1,
    flexBasis: "15%",
    maxWidth: "15%",
  },
  td: {
    flex: 1,
    flexBasis: "35%",
    maxWidth: "35%",
    screen: ({ width }) => {
      if (width <= 991)
        return {
          marginBottom: 5,
          flexBasis: "100%",
          maxWidth: "100%",
          flexDirection: "row",
        };
    },
  },
  tdStatus: {
    screen: ({ width }) => {
      if (width >= 992)
        return {
          flex: 1,
          flexBasis: "15%",
          maxWidth: "15%",
        };
    },
  },
  providerListComponent: {
    backgroundColor: "#fff",
    marginTop: 164,
    marginRight: 16,
    marginBottom: 70,
    marginLeft: 16,
    paddingTop: 0,
    // paddingRight: 16,
    paddingBottom: 16,
    // paddingLeft: 16,
    display: "block",
    flexGrow: 0,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#e2e2e2",
    // borderTopWidth: 0,
    // position: "unset",
    screen: ({ width }) => {
      if (width >= 992 && width <= 1024) {
        return {
          marginTop: 184,
        };
      }
      if (width >= 320 && width <= 991) {
        return {
          // paddingTop: 16,
          borderTopWidth: 1,
          paddingRight: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          marginBottom: 100,
          marginRight: 0,
          marginLeft: 0,
        };
      }
    },
  },
  bodyWrapper: {
    width: 300,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
    screen: ({ width }) => {
      if (width <= 991)
        return {
          width: 300,
          minHeight: 150,
          maxHeight: 200,
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          borderRadius: 6,
          fontWeight: 600,
        };
    },
  },
  customFlexDirection: {
    flexDirection: "row",
    justifyContent: "space-between",
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          display: "block",
          flexDirection: "column",
          maxWidth: "100%",
          flexBasis: "100%",
        };
      }
    },
  },
  noRecordFound: {
    marginBottom: 50,
  },
  noItemsComponent: {
    marginTop: 0,
    marginRight: 16,
    marginBottom: 0,
    marginLeft: 16,
    backgroundColor: "#fff",
    padding: 0,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#e2e2e2",
    height: "100%",
    screen: ({ width }) => {
      if (width <= 991)
        return {
          marginTop: 0,
          marginRight: 0,
          marginBottom: 100,
          marginLeft: 0,
          borderWidth: 0,
        };
    },
  },
  noPIDComponent: {
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    backgroundColor: "#fff",
    padding: 0,
    borderWidth: 0,
    borderStyle: "solid",
    borderColor: "#e2e2e2",
    position: "relative",
    screen: ({ width }) => {
      if (width <= 991)
        return {
          marginTop: 60,
          marginRight: 0,
          marginBottom: 100,
          marginLeft: 0,
        };
    },
  },
  borderWidth0: {
    borderWidth: 0
  },
  customMarginTop: {
    margin: 0,
    position: "relative",
    borderWidth: 0,
    top: 0,
  },
  borderBottomWidth0: {
    borderBottomWidth: 0
  },
  mobileLabels: {
    marginRight: 10,
    minWidth: 100,
  },
  pidButtonContainer: {
    marginRight: 16,
    maxWidth: "50%",
    marginLeft: "auto",
    screen: ({ width }) => {
      if (width <= 991)
        return {
          marginLeft: 16,
          maxWidth: "100%"
        };
    },
  },
  checkboxContainer: {
    flex: 1,
    flexBasis: "5%",
    maxWidth: "5%",
    marginTop: -8,
    screen: ({ width }) => {
      if (width <= 991)
        return {
          marginBottom: 5,
          flexBasis: 38,
          maxWidth: 38,
          flexDirection: "row",
        };
    },
  },
  modalOuterWrapper: {
    backgroundColor: "#00000059",
  },
  buttonWrapper: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    marginTop: 15,
  },
  buttons: {
    width: 90,
    minWidth: "40%",
  },
  btnTexClr: {
    color: "#333",
  },
  justifyContentSpaceBetween: {
    justifyContent: "space-between",
    screen: ({ width }) => {
      if (width <= 991)
        return {
          justifyContent: "flex-start",
        };
    },
  },
  customActiveBtnStyle: {
    screen: ({ width }) => {
      if (width >= 992)
        return {
          marginLeft: 0,
          marginRight: 0,
          maxWidth: 150
        };
    },
  },
  customInactiveBtnStyle: {
    screen: ({ width }) => {
      if (width >= 992)
        return {
          maxWidth: 150
        };
    },
  },
  customListHeight: {
    height: "calc(50vh)",
    screen: ({ width }) => {
      if (width <= 991)
        return {
          height: "calc(70vh)"
        };
    },
  },
  marginLeftRight16: {
    marginLeft: 16,
    marginRight: 16,
  },    
  disabledBtn: {
    opacity: 0.5,
    cursor: "no-drop",
    pointerEvents: "none",
  },
  flexWrap: {
      screen: ({ width }) => {
        if (width <= 991)
          return {
            flexShrink: 1,
            flexWrap: "wrap",
            maxWidth: "75%",
        };
    },
  },
})